import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, catchError, map, throwError } from 'rxjs';
import { GetPagesForMenuResponseViewDto, PagesForAdminService, PagesForUserService } from '@src/api';
import { AlertService } from '@src/core/services';

import { PageListItemType, PageNavigationItemType } from '../types';
import { NAVIGATION_ITEMS, NavigationItem } from '../../navigation';

@Injectable({
  providedIn: 'root',
})
export class PagesService {
  private readonly pagesForUserService = inject(PagesForUserService);
  private readonly pagesForAdminService = inject(PagesForAdminService);
  private readonly alertService = inject(AlertService);

  readonly pagesList$ = new BehaviorSubject<PageListItemType[] | null>(null);
  readonly pagesForNavigation$ = new BehaviorSubject<PageNavigationItemType[] | null>(null);

  getPagesList() {
    this.pagesForAdminService
      .getPagesForAdmin()
      .pipe(
        catchError(err => {
          this.alertService.error(err);

          return throwError(() => err);
        }),
      )
      .subscribe(pages => this.pagesList$.next(pages));
  }

  resetPagesList(): void {
    this.pagesList$.next(null);
  }

  getPagesForNavigation() {
    this.pagesForUserService
      .getPagesForMenu()
      .pipe(
        map(items => this.mapPagesForMenuToPagesForNavigation(items)),
        catchError(err => {
          this.alertService.error(err);

          return throwError(() => err);
        }),
      )
      .subscribe(pagesForNavigation => {
        this.pagesForNavigation$.next(pagesForNavigation);
      });
  }

  private mapPagesForMenuToPagesForNavigation(items: GetPagesForMenuResponseViewDto[]): NavigationItem[] {
    const baseItem = NAVIGATION_ITEMS.find(item => item.id === 'menu.administrationPages');
    return items.map(item => {
      return <NavigationItem>{
        ...baseItem,
        ...{
          title: item.title,
          link: '/pages/' + item.id,
          permissions: undefined, // INFO: пока отображаем всем
        },
      };
    });
  }
}
